// Simple zone mapping - hardcoded zones
// Zone 1: A,B | Zone 2: C,D | Zone 3: E,F | Zone 4: G,H | etc.

const ZONE_MAPPING = {
  'A': { zone: 1, color: '#E3F2FD' }, // Light Blue
  'B': { zone: 1, color: '#E3F2FD' },
  'C': { zone: 2, color: '#E8F5E8' }, // Light Green
  'D': { zone: 2, color: '#E8F5E8' },
  'E': { zone: 3, color: '#FFF3E0' }, // Light Orange
  'F': { zone: 3, color: '#FFF3E0' },
  'G': { zone: 4, color: '#F3E5F5' }, // Light Purple
  'H': { zone: 4, color: '#F3E5F5' },
  'I': { zone: 5, color: '#FFF8E1' }, // Light Yellow
  'J': { zone: 5, color: '#FFF8E1' },
  'K': { zone: 6, color: '#FFEBEE' }, // Light Pink
  'L': { zone: 6, color: '#FFEBEE' },
  'M': { zone: 7, color: '#E0F2F1' }, // Light Teal
  'N': { zone: 7, color: '#E0F2F1' },
};

/**
 * Gets zone info for a row
 */
export const getZoneForRow = (rowLabel) => {
  return ZONE_MAPPING[rowLabel] || { zone: 1, color: '#f5f5f5' };
};

/**
 * Groups rows by zones
 */
export const groupRowsByZones = (rows) => {
  const zones = {};

  rows.forEach(row => {
    const { zone: zoneNumber, color } = getZoneForRow(row.label);

    if (!zones[zoneNumber]) {
      zones[zoneNumber] = {
        zoneNumber,
        zoneName: `Zone ${zoneNumber}`,
        zoneColor: color,
        rows: []
      };
    }

    zones[zoneNumber].rows.push(row);
  });

  return zones;
};

/**
 * Gets zone display name
 */
export const getZoneDisplayName = (zoneNumber) => {
  const zoneRows = Object.entries(ZONE_MAPPING)
    .filter(([_, info]) => info.zone === zoneNumber)
    .map(([row, _]) => row);

  return `Zone ${zoneNumber} (Rows ${zoneRows.join(',')})`;
};